import { Select } from "antd";
import type { FilterTypes } from "../types";

export interface IMultipleSelectFilterOption {
  label: string;
  value: string;
}

export interface IMultipleSelectFilterProperties {
  filterType: FilterTypes;
  placeholder?: string;
  options: IMultipleSelectFilterOption[];
  onChange: (filterType: FilterTypes, values: string[]) => void;
}

export const MultipleSelectFilter = (properties: IMultipleSelectFilterProperties) => {
  return (
    <Select
      style={{ minWidth: "130px" }}
      mode={"multiple"}
      maxTagCount={1}
      popupMatchSelectWidth={false}
      placeholder={properties.placeholder}
      onChange={(values: string[]) => properties.onChange(properties.filterType, values)}
      filterOption={(input, option) => (option?.label ?? "").toLowerCase().includes(input?.toLowerCase())}
      options={properties.options || []}
    />
  );
};
